import React from 'react';
import { ReactComponent as ShowPasswordIconIconSvg } from '@images/auth/show-password-login.svg';

export const ShowPasswordIcon = () => {
  return <ShowPasswordIconIconSvg />;
};
